<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="students"
      :hide-default-footer="true"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <details-students
          :id="item.actions.id"
          type-student="tutor"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex'
  import DetailsStudents from '@/views/dashboard/pages/panel/DetailsStudents'

  export default {
    components: {
      DetailsStudents,
    },
    data () {
      return {
        headers: [
          { text: 'Nombre', value: 'details.firstname', aling: 'center', sortable: false},
          { text: 'Apellido', value: 'details.lastname', aling: 'center', sortable: false },
          { text: 'Acciones', value: 'actions', sortable: false},
        ],
        sortBy: 'details.lastname',
        sortDesc: false,
      }
    },
    methods:{
      customSort(items, index, isDesc) {
        items.sort((a, b) => {
              return a.details.lastname - b.details.lastname;
        });
        return items;
      }
    },
    computed: {
      ...mapState(['userData']),
      students () {

      return this.userData.students;

        //return this.userData.students.sort( (a,b ) => a.lastname - b.lastname );
      },

    },
  }
</script>
